<template>
	<svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_10196_4540)">
			<path
				d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
				:fill="color" />
		</g>
		<defs>
			<clipPath id="clip0_10196_4540">
				<rect :width="width" :height="height" fill="white" />
			</clipPath>
		</defs>
	</svg>
</template>

<script>
import { extractValueAndUnit } from '../../utils/iconUtils'

export default {

	name: 'IconCirclePlus',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '1.5rem',
		},

		height_prop: {
			type: String,
			default: '1.5rem',
		},

		color_prop: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
		}
	},

	computed: {
		color() {
			return this.color_prop || getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
		},

		width() {
			const { value, unit } = extractValueAndUnit(this.width_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},

		height() {
			const { value, unit } = extractValueAndUnit(this.height_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},
	},
}
</script>